import { useContext, useState, useEffect } from "react";
import { getGeolocationCookieData } from "utils/cookie";
import { Context } from "Context";
import appConfig from "config.json";
const {
	cookies,
	launchDarkly: { clientSideIds },
} = appConfig;

const useLaunchDarklyClient = () => {
	const [ldClient, setLdClient] = useState(null);
	const [flags, setFlags] = useState({});
	const [isClientReady, setIsClientReady] = useState(false);

	const {
		config: { brand, locale, environment },
		updatedLocation,
		profileData: { user, isLoading },
	} = useContext(Context);

	const { country, region, city } = getGeolocationCookieData(
		null,
		cookies.geolocation
	);

	useEffect(() => {
		if (isLoading || !brand || !locale || (user && !user.isDataLoaded)) {
			return;
		}

		const currentContext = {
			anonymous: true,
			brand,
			city,
			country,
			currentPage: updatedLocation || window.location.pathname,
			kind: "user",
			locale,
			authenticated: user?.swid ? "yes" : "no",
			region,
		};

		if (window.LDClient) {
			initializeClient(window.LDClient);
			return;
		}
		return () => {
			if (ldClient) {
				ldClient.close();
			}
		};

		function initializeClient(LDClient) {
			const client = LDClient.initialize(
				clientSideIds[environment] || clientSideIds.default,
				currentContext
			);
			setLdClient(client);
			client.on("ready", () => {
				setIsClientReady(true);
				setFlags(client.allFlags());
			});
			client.on("change", (changes) => {
				setFlags((prevFlags) => ({ ...prevFlags, ...changes }));
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [brand, locale, updatedLocation, user, isLoading, cookies.geolocation]);

	return { flags, isClientReady };
};

export default useLaunchDarklyClient;
